export default [

  {
    path: "/products/list",
    name: "products-list",
    component: () => import("@/views/product/products-list/productsList.vue"),
    meta: {
      action: "read",
      resource: "products",
    },
  },
  {
    path: "/product/edit/:id",
    name: "product-edit",
    component: () => import("@/views/product/product-edit/productEdit.vue"),
    meta: {
      action: "update",
      resource: "products",
    },
  },
  {
    path: "/product/create",
    name: "product-create",
    component: () => import("@/views/product/product-edit/productEdit.vue"),
    meta: {
      action: "create",
      resource: "products",
    },
  }
]